/* unplugin-vue-components disabled */import { render } from "./ImageCompare.vue?vue&type=template&id=401b0315&scoped=true&ts=true"
import script from "./ImageCompare.vue?vue&type=script&lang=ts"
export * from "./ImageCompare.vue?vue&type=script&lang=ts"

import "./ImageCompare.vue?vue&type=style&index=0&id=401b0315&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401b0315"]])

export default __exports__